/*
	This is a reducer that ONLY HOUSES ANALYTICS calls.
	It contains no internal state.
	It only subscribes to the actions in the signup ducks file,
	and composes the state to
*/

import Analytics from "./util/Analytics";

import {
	UPLOAD_FACEBOOK_PHOTO_SUCCESS,
} from "ducks/photo_organizer";


// ////////////////////////
// REDUCER ///////////////
// //////////////////////

export default function photoUpload(state, action) {
	switch (action.type) {
		case UPLOAD_FACEBOOK_PHOTO_SUCCESS: {
			const data = {
				"photo source": "facebook",
				"source of upload": "onboarding",
				"photo count": 1,
			};

			Analytics.logUIEvent(
				Analytics.eventNames.uploadedPhoto,
				{ data },
			);
			return;
		}

		default: {
			return;
		}
	}
}



// WEBPACK FOOTER //
// ./src/analytics/photo_organizer.js